<template>
  <div class="teaching-arrange-schedule-add">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    title="添加课程"
                    width="960px"
                    custom-class="teaching-arrange-schedule-add-dialog">
      <TeachingArrangeScheduleAddMain :visible="visible"
                                      v-bind="$attrs"
                                      :map-key="mapKey"
                                      :circle-radius="circleRadius"
                                      @hidePopover="hidePopover"
                                      @addSuccess="onAddSuccess"></TeachingArrangeScheduleAddMain>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../elements/grid/DataGridDialog'
import TeachingArrangeScheduleAddMain from './main'
export default {
  name: 'TeachingArrangeScheduleAdd',
  components: {
    DataGridDialog,
    TeachingArrangeScheduleAddMain
  },
  props: {
    mapKey: {
      type: String,
      required: true
    },
    circleRadius: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    hidePopover () {
      this.visible = false
    },
    onAddSuccess () {
      this.visible = false
      this.$nextTick(() => {
        this.$emit('refresh')
      })
    }
  }
}
</script>

<style lang="scss">
.teaching-arrange-schedule-add-dialog {
  width: 960px;
  max-width: calc(100vw - 48px) !important;
  height: 760px;
  max-height: 88vh;
  margin-top: 6vh !important;
  display: flex;
  flex-direction: column;

  > .el-dialog__header {
    flex: none;
  }

  > .el-dialog__body {
    flex: auto;
    min-height: 0;
    overflow: hidden;
  }
}
</style>
